import React, { useEffect, useMemo, useRef, useState } from "react";

export function ItemScroller({
    items = [],
    schema = { name: "name", image: "image" },
    // 👇 px per second (tamare speed high/low karvi hoi to aa prop change karo)
    speed = 40,
}) {
    const scrollRef = useRef(null);

    const [isPaused, setIsPaused] = useState(false);
    const isPausedRef = useRef(false);
    const speedRef = useRef(speed);
    const positionRef = useRef(0);
    const lastTimeRef = useRef(null);

    // keep ref in sync (hover par effect re-run nai thato)
    useEffect(() => {
        isPausedRef.current = isPaused;
    }, [isPaused]);

    useEffect(() => {
        speedRef.current = speed;
    }, [speed]);

    // 🔁 double list for seamless loop
    const loopItems = useMemo(() => {
        if (!items || items.length === 0) return [];
        return [...items, ...items];
    }, [items]);

    useEffect(() => {
        const container = scrollRef.current;
        if (!container) return;

        let frameId;

        const step = (timestamp) => {
            if (lastTimeRef.current == null) {
                lastTimeRef.current = timestamp;
            }

            const delta = timestamp - lastTimeRef.current; // ms
            lastTimeRef.current = timestamp;

            if (
                !isPausedRef.current &&
                container.scrollWidth > container.clientWidth
            ) {
                const fullWidth = container.scrollWidth;
                const singleWidth = fullWidth / 2; // ek copy width

                // px/sec  → px/frame
                const distance = (speedRef.current * delta) / 1000;

                let nextPos = positionRef.current + distance;

                // wrap for infinite loop
                if (nextPos >= singleWidth) {
                    nextPos -= singleWidth;
                }

                positionRef.current = nextPos;
                container.scrollLeft = nextPos;
            }

            frameId = requestAnimationFrame(step);
        };

        frameId = requestAnimationFrame(step);

        return () => {
            cancelAnimationFrame(frameId);
            lastTimeRef.current = null;
        };
    }, [loopItems.length]);

    return (
        <div
            className="relative w-full py-8"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            <div
                ref={scrollRef}
                className="flex gap-7 overflow-hidden"
                style={{ willChange: "scroll-position" }}
            >
                {loopItems.map((pointDetails, index) => {
                    const name = pointDetails[schema?.name || "name"];
                    const image = pointDetails[schema?.image || "image"];

                    return (
                        <div
                            key={`${index}_${name}`}
                            className="flex flex-col items-center w-40 flex-shrink-0"
                        >
                            <img
                                src={image}
                                alt={(name || "").replace(/ /g, "-")}
                                className="w-40 h-40 rounded-full object-cover mb-2 border-2"
                            />
                            <div className="flex flex-col text-white items-center text-center text-md px-2">
                                {name}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
